<template>
  <div class="profile">Redirect...</div>
</template>

<script>
import { mapActions } from 'vuex';
// @ is an alias to /src

export default {
  name: "profile",
  components: {},
  methods: {
    ...mapActions({
      loginActions: 'login'
    }),
    redirect() {
      let data = this.$route.query
      if (data.user == null || data.password == null) {
        this.$router.replace('/login')
        return false
      }
      
      this.login(data.user, data.password)
    },
    login(username, password) {
      let payload = {
        username: username,
        password: password
      }
      // console.log(payload)
      this.loginActions(payload)
      .then((res) => {
        // console.log(res)
        this.$router.replace('/dashboard')
      }) 
      .catch((err) => {
        // console.log(err)
        alert(err)
        this.$router.replace('/login')
      })
    }
  },
  mounted() {
    this.redirect();
  }
};
</script>
